var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeachicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5422_19526",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5422_19526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 20.999C4.45 20.999 3.97917 20.8032 3.5875 20.4115C3.19583 20.0199 3 19.549 3 18.999V4.99902C3 4.44902 3.19583 3.97819 3.5875 3.58652C3.97917 3.19486 4.45 2.99902 5 2.99902H9.2C9.41667 2.39902 9.77917 1.91569 10.2875 1.54902C10.7958 1.18236 11.3667 0.999023 12 0.999023C12.6333 0.999023 13.2042 1.18236 13.7125 1.54902C14.2208 1.91569 14.5833 2.39902 14.8 2.99902H19C19.55 2.99902 20.0208 3.19486 20.4125 3.58652C20.8042 3.97819 21 4.44902 21 4.99902V18.999C21 19.549 20.8042 20.0199 20.4125 20.4115C20.0208 20.8032 19.55 20.999 19 20.999H5ZM5 18.999H19V4.99902H5V18.999ZM7 16.999H14V14.999H7V16.999ZM7 12.999H17V10.999H7V12.999ZM7 8.99902H17V6.99902H7V8.99902ZM12 4.24902C12.2167 4.24902 12.3958 4.17819 12.5375 4.03652C12.6792 3.89486 12.75 3.71569 12.75 3.49902C12.75 3.28236 12.6792 3.10319 12.5375 2.96152C12.3958 2.81986 12.2167 2.74902 12 2.74902C11.7833 2.74902 11.6042 2.81986 11.4625 2.96152C11.3208 3.10319 11.25 3.28236 11.25 3.49902C11.25 3.71569 11.3208 3.89486 11.4625 4.03652C11.6042 4.17819 11.7833 4.24902 12 4.24902Z",
    fill: "#2D2F31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeachicon);
export default __webpack_public_path__ + "static/media/Teachicon.e3459d9d05aa300ed6337535bfc82101.svg";
export { ForwardRef as ReactComponent };